import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import questionIcon from "../../../assets/icons/question.svg";
import downIcon from "../../../assets/icons/down-chevron.svg";

// Style
import "./CategorySelector.scss";

const CategorySelector = ({
  isModalOpen,
  listCategories,
  selectedCategory,
  setSelectedCategory,
  newCategory,
  setNewCategory,
  selectedTag,
  isReplaceOldCategory,
  setIsReplaceOldCategory,
}) => {
  const [categoryString, setCategoryString] = useState("");
  const [isSeachDropdownOpen, setIsSeachDropdownOpen] = useState(false);

  useEffect(() => {
    if (selectedTag) {
      setCategoryString(selectedTag.category.name);
    }
  }, [selectedTag]);

  const handleCategoryStringChange = (e) => {
    setCategoryString(e.target.value);
    const category = listCategories.filter(
      (listCategory) => listCategory.name.toLowerCase() === e.target.value.toLowerCase()
    );
    if (category.length === 1) {
      setSelectedCategory(category[0]);
    } else {
      setSelectedCategory(null);
    }
    setNewCategory(null);
    setIsSeachDropdownOpen(true);
  };

  const searchedCategories =
    categoryString === ""
      ? listCategories
      : listCategories.filter((listCategory) => listCategory.name.toLowerCase().includes(categoryString.toLowerCase()));

  const handleSelectCategory = (category) => {
    setCategoryString(category.name);
    setSelectedCategory(category);
    setIsSeachDropdownOpen(false);
    setNewCategory(null);
  };

  const handleAddNewCategory = () => {
    setNewCategory(categoryString.trim());
    setIsSeachDropdownOpen(false);
    setSelectedCategory(null);
  };

  const categorySearchDropdownRef = useRef();

  const handleClickOutsideOfUserSearch = (event) => {
    if (
      categorySearchDropdownRef &&
      categorySearchDropdownRef.current &&
      !categorySearchDropdownRef.current.contains(event.target)
    ) {
      setIsSeachDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideOfUserSearch);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideOfUserSearch);
    };
  }, []);

  useEffect(() => {
    if (!isModalOpen) {
      setCategoryString("");
      setIsSeachDropdownOpen(false);
      setIsReplaceOldCategory(false);
    }
  }, [isModalOpen, setIsReplaceOldCategory]);

  return (
    <div className="category-selector">
      <div className="form-groups">
        <div className="form-group">
          <label>
            <strong>Category Name </strong>
            <ReactTooltip id="tag-category-tooltip" place="top" effect="solid" className="category-selector-tooltip">
              Define a category to organize your unique tags. E.g. - Vendors, locations, individuals etc.
            </ReactTooltip>
            <img
              className="hint"
              width="18"
              height="18"
              src={questionIcon}
              alt="hint"
              data-tip
              data-for="tag-category-tooltip"
            />
          </label>
          <div className="input-dropdown" ref={categorySearchDropdownRef}>
            <input
              type="text"
              value={categoryString}
              onChange={handleCategoryStringChange}
              placeholder="Select or enter category name"
              onFocus={() => setIsSeachDropdownOpen(true)}
            />
            <img
              className="dropdown"
              width="20"
              height="20"
              src={downIcon}
              alt="dropdown"
              onClick={() => setIsSeachDropdownOpen((isSeachDropdownOpen) => !isSeachDropdownOpen)}
            />
            {isSeachDropdownOpen ? (
              <div className="category-search-dropdown">
                {searchedCategories.map((searchedCategory) => (
                  <div
                    className={`category-search-dropdown-row ${
                      selectedCategory && selectedCategory.id === searchedCategory.id ? "selected" : ""
                    } `}
                    key={searchedCategory.id}
                    onClick={() => handleSelectCategory(searchedCategory)}
                  >
                    {searchedCategory.name}
                  </div>
                ))}
                {!selectedCategory && categoryString.trim().length > 0 && !newCategory ? (
                  <div className="category-search-dropdown-row-add " onClick={handleAddNewCategory}>
                    ＋ Add {categoryString}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
        {(selectedTag &&
          selectedCategory &&
          selectedTag.category.name.toLowerCase() !== selectedCategory.name.toLowerCase()) ||
        newCategory ? (
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input disabled"
              checked={isReplaceOldCategory}
              onChange={() => {
                setIsReplaceOldCategory((isReplaceOldCategory) => !isReplaceOldCategory);
              }}
              id="replace-old-category"
            />
            <label className="form-check-label" htmlFor="replace-old-category">
              Replace the old category name for all related tags
            </label>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CategorySelector;
